import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-favorite-button', {
    display: 'inline-block',
    verticalAlign: 'top',
    width: 'var(--header-button-size, 24px)',
    minWidth: 'var(--header-button-size, 24px)',
    height: 'var(--header-button-size, 24px)',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url(img/Spaces_Caption_Favorite_Off.svg?1_0_9606_yabs0uv7t1h)',
    backgroundSize: 'var(--header-icon-size, 18px)',
    border: '1px solid transparent',
    boxSizing: 'border-box',
    borderRadius: '2px',
});

cssRule('.tb-favorite-button:hover', {
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.hover, 'var(--header-background-hover-color), #ebebeb'),
    backgroundImage: 'url(img/Spaces_Caption_Favorite_Off_Active.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-favorite-button.tb-selected', {
    backgroundImage: 'url(img/Spaces_Caption_Favorite_On.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-favorite-button.tb-selected:hover', {
    backgroundImage: 'url(img/Spaces_Caption_Favorite_On_Active.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-favorite-button-light', {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '24px',
    minWidth: '24px',
    height: '24px',
    padding: '3px',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url(img/Spaces_Caption_Favorite_Off_White.svg?1_0_9606_yabs0uv7t1h)',
    backgroundSize: '18px',
    border: '1px solid transparent',
});

cssRule('.tb-favorite-button-light:hover', {
    backgroundImage: 'url(img/Spaces_Caption_Favorite_Off_Active_White.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-favorite-button-light.tb-selected', {
    backgroundImage: 'url(img/Spaces_Caption_Favorite_On_White.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-favorite-button-light.tb-selected:hover, .tb-favorite-button-light.tb-selected:focus', {
    backgroundImage: 'url(img/Spaces_Caption_Favorite_On_Active_White.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-favorite-button-cell', {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '37px',
    height: '37px',
    lineHeight: '37px',
});

cssRule('.tb-favorite-button-cell .tb-favorite-button', {
    position: 'relative',
    top: '6px',
    left: '6px',
});

cssRule('.tb-favorites-dropdown img', {
    display: 'none',
});

cssRule('.tb-favorites-dropdown button', {
    backgroundColor: 'inherit !important',
});

cssRule('.tb-favorites-dropdown span', {
    padding: 0,
});

